import * as React from 'react';
import { graphql } from 'gatsby';
import { Router } from '@reach/router';
import ShopPage from './shop-page';
import './lazy-components';

export default (props) => (
    <div>
        <Router>
            <ShopPage path="/shop/category/:id" {...props}></ShopPage>
            <ShopPage path="/product/:slug" {...props}></ShopPage>
        </Router>
    </div>
)

export const TemplatePagesQuery = graphql`
query templates($page: String!) {
    allBuilderModels {
        template(
            options: {cachebust: true, noTraverse: false},
            target: { urlPath: $page }
            limit: 1
        ) {
            content
        }
    }
}`